import { guardClient } from '../_axios'

/**
 * 注力顧客の要約更新
 * [patch]/company/:companyId/summary
 */
export const updateCompanySummary = async (
  companyId: number,
  summary: string | null
): Promise<void> => {
  const path = `/company/${companyId}/summary`
  await guardClient.patch(path, { summary: summary ?? undefined })
}
